/**
 * 埋点模块 - GrowingIO
 * 负责初始化 GrowingIO WebJS SDK
 * 文档: https://growingio.github.io/growingio-sdk-docs/docs/webjs/initSettings
 */

import gdp from 'gio-webjs-sdk/gdp-full'
import { isDebugMode, isDevelopment } from '@/utils'
import { setGeneralProps } from '@/utils/tracker'

/**
 * 初始化埋点
 */
export function initTracker() {
  gdp(
    'init',
    import.meta.env.VITE_GDP_ACCOUNT_ID,
    import.meta.env.VITE_GDP_DATA_SOURCE_ID,
    {
      version: __APP_VERSION__,
      debug: isDebugMode,
      // OP私有部署客户请填写serverUrl，Saas客户请忽略
      // serverUrl: 'https://napi.growingio.com',
      // hash 路由模式下，需要开启 hashtag 模式
      hashtag: true,
      // 是否开启数据采集，开发环境关闭
      dataCollect: !isDevelopment,
      // 是否自动采集页面访问事件，开发环境关闭
      trackPage: !isDevelopment,
      // 是否采集爬虫环境数据，开发环境关闭
      trackBot: !isDevelopment,
      isMapping: true,
    })

  // 设置全局通用属性
  setGeneralProps({
    // 渠道标识（从配置中获取）
    channel: import.meta.env.VITE_CHANNEL,
    // 包名
    packageName: import.meta.env.VITE_PACKAGE_NAME,
    // 版本号
    version: __APP_VERSION__,
    // 环境
    environment: import.meta.env.MODE,
  })
}
